import { Component, type ReactNode, type ErrorInfo } from 'react'

/* A class error boundary whose sole extra job over the router's errorElement is
   to capture React's component stack. Effect-cleanup errors ("destroy is not a
   function") surface as bare React-internal traces with no app frames, so the
   ONLY way to learn which component owns the failing effect is componentDidCatch's
   errorInfo.componentStack. We log it loudly (with a copyable marker) and show a
   recoverable Reload screen. Paired with esbuild keepNames, the stack is readable
   in production. */
export class DiagnosticBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Grouped + prefixed so a tester can copy the whole block from the console.
    console.error('=== LIFECRAFT CRASH REPORT (copy everything below) ===')
    console.error('message:', error?.message)
    console.error('error.stack:', error?.stack)
    console.error('componentStack:', info?.componentStack)
    console.error('=== END LIFECRAFT CRASH REPORT ===')
  }

  render() {
    if (!this.state.hasError) return this.props.children
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0b0f0a', color: '#e9efe6', padding: 24, fontFamily: 'system-ui, sans-serif', textAlign: 'center' }}>
        <div style={{ maxWidth: 440 }}>
          <h1 style={{ fontSize: '1.6rem', marginBottom: 12 }}>Something went wrong</h1>
          <p style={{ opacity: 0.7, marginBottom: 24, fontSize: '0.95rem', lineHeight: 1.5 }}>
            The page hit an unexpected error. Reloading usually clears it.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{ background: '#c8f169', color: '#0b0f0a', border: 0, borderRadius: 999, padding: '12px 30px', fontWeight: 700, cursor: 'pointer', fontSize: '0.95rem' }}
          >
            Reload
          </button>
          <p style={{ marginTop: 18, fontSize: '0.9rem' }}>
            <a href="/" style={{ color: '#c8f169' }}>Back to home</a>
          </p>
        </div>
      </div>
    )
  }
}
